import React from 'react';
import styles from '~/widgets/StatAdjuster/StatAdjuster.module.scss';

export interface StatAdjusterProps {
  value: number;
  onIncrement: () => void;
  onDecrement: () => void;
  onClear?: () => void;
  min?: number;
  label: string;
}

export const StatAdjuster: React.FC<StatAdjusterProps> = ({
  value,
  onIncrement,
  onDecrement,
  onClear,
  min = 0,
  label,
}) => {
  return (
    <div className={styles.container}>
      <button
        onClick={onDecrement}
        disabled={value <= min}
        aria-label={`Decrease ${label}`}
        className={`${styles.button} ${styles.buttonDefault}`}
      >
        -
      </button>
      {onClear && (
        <button
          onClick={onClear}
          disabled={value <= min}
          className={`${styles.button} ${styles.buttonClear}`}
        >
          Clear
        </button>
      )}
      <button
        onClick={onIncrement}
        aria-label={`Increase ${label}`}
        className={`${styles.button} ${styles.buttonDefault}`}
      >
        +
      </button>
    </div>
  );
};
